import React from 'react';

interface IconCheckingAccountProps {
  size?: string;
  color?: string;
}

export const IconCheckingAccount: React.FC<IconCheckingAccountProps> = ({
  size = '24px',
  color = '#232429',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 4.5C22.9926 4.5 24 5.50736 24 6.75V17.25C24 18.4926 22.9926 19.5 21.75 19.5H2.25C1.00736 19.5 0 18.4926 0 17.25V6.75C0 5.50736 1.00736 4.5 2.25 4.5H21.75ZM6.5 12.75C6.22398 12.7501 6.00006 12.974 6 13.25V16.5H5C4.72398 16.5001 4.50006 16.724 4.5 17V17.5C4.50006 17.776 4.72398 17.9999 5 18H19C19.276 17.9999 19.4999 17.776 19.5 17.5V17C19.4999 16.724 19.276 16.5001 19 16.5H18V13.25C17.9999 12.974 17.776 12.7501 17.5 12.75H17C16.724 12.7501 16.5001 12.974 16.5 13.25V16.5H15V13.25C14.9999 12.974 14.776 12.7501 14.5 12.75H14C13.724 12.7501 13.5001 12.974 13.5 13.25V16.5H10.5V13.25C10.4999 12.974 10.276 12.7501 10 12.75H9.5C9.22398 12.7501 9.00006 12.974 9 13.25V16.5H7.5V13.25C7.49994 12.974 7.27602 12.7501 7 12.75H6.5ZM12.5547 6.37012C12.2188 6.1463 11.7812 6.14622 11.4453 6.37012L4.37402 11.084C3.96258 11.3584 4.15684 11.9998 4.65137 12H19.3486C19.8431 11.9998 20.0373 11.3584 19.626 11.084L12.5547 6.37012ZM12 8.25C12.6212 8.2501 13.1249 8.75379 13.125 9.375C13.1249 9.99621 12.6212 10.4999 12 10.5C11.3788 10.4999 10.8751 9.99621 10.875 9.375C10.8751 8.75379 11.3788 8.2501 12 8.25Z"
        fill={color}
      />
    </svg>
  );
};
